import { Trans, useTranslation } from 'react-i18next';

import Card from '@mui/material/Card';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface MultisiteInfoProps {
  multisiteLearnMoreUrl: string | undefined;
}
const MultisiteInfo = ({ multisiteLearnMoreUrl }: MultisiteInfoProps) => {
  const { t } = useTranslation('addSites', { keyPrefix: 'multisiteInfo' });
  return (
    <Card sx={{ backgroundColor: ({ palette }) => palette.info.light, p: 2 }}>
      <Stack
        component="ul"
        direction="column"
        spacing={1.5}
        sx={{ m: 0, pl: 2.5 }}
      >
        <Typography component="li" variant="body1">
          <Trans>{t('networkConfigurationInfo')}</Trans>
        </Typography>
        <Typography component="li" variant="body1">
          <Trans
            t={t}
            i18nKey="networkConfigurationInfoDesc"
            components={{
              Link: <Link target="_blank" href={multisiteLearnMoreUrl} />,
            }}
          />
        </Typography>
      </Stack>
    </Card>
  );
};
export default MultisiteInfo;
